import { ArtistSettingsScreen } from "@components/Account/Artist/Settings";

export default ArtistSettingsScreen;
